import React, {useRef} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import ListItemText from '@material-ui/core/ListItemText';
import { blackColor } from 'assets/jss/material-dashboard-react.js';
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { FormControl, Input } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import fileDownload from 'js-file-download';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';

// const useStyles = makeStyles(styles);
import {
    whiteColor,
    grayColor
} from "assets/jss/material-dashboard-react.js";
import { func } from 'prop-types';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    smallAvatar: {
        display: 'flex',
        width: "25px",
        height: "25px",
    },
    smallAvatarSuccess: {
        width: "25px",
        height: "25px",
        backgroundColor: "#004F69",
    },
    orange: {
        color: theme.palette.getContrastText(blackColor),
        backgroundColor: blackColor,
    },
    cardTitleWhite: {
        color: whiteColor,
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: grayColor[1],
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    log: {
        "font-family": "Courier New",
        fontSize: 16
    },
    formControl: {
        width: '100%'
      },


}));

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  
const DialogContent = withStyles((theme) => ({
root: {
    padding: theme.spacing(2),
    backgroundColor: "lightgray",
},
}))(MuiDialogContent);

//SideNav
const useStepperStyles = makeStyles((theme) => ({
root: {
    width: '100%',
},
button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
},
actionsContainer: {
    marginBottom: theme.spacing(2),
},
resetContainer: {
    padding: theme.spacing(3),
},
}));

//Select
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MasterForm(props) {

    const [resourceGroup, setResourceGroup] = React.useState("");
    const [location, setLocation] = React.useState("");
    const [clusterName, setClusterName] = React.useState("");
    const [numberNodes, setNumberNodes] = React.useState("");
    const [namespace, setNamespace] = React.useState("");
    const [artifacts, setArtifacts] = React.useState("network/artifacts");
    const [batchTimeout, setBatchTimeout] = React.useState("");
    const [maxMessageCount, setMaxMessageCount] = React.useState("");
    const [absoluteMaxBytes, setAbsoluteMaxBytes] = React.useState("");
    const [preferredMaxBytes, setPreferredMaxBytes] = React.useState("");
    const [ca, setCa] = React.useState("");
    const [peer, setPeer] = React.useState("");
    const [tools, setTools] = React.useState("");
    const [orderer, setOrderer] = React.useState("");
    const [couchdb, setCouchdb] = React.useState("");
    const [core, setCore] = React.useState("./network/scripts/core.yaml");
    const [externalBuilder, setExternalBuilder] = React.useState("./network/externalBuilder");
    const [consortium, setConsortium] = React.useState("SampleConsortium");
    const [count, setCount] = React.useState("");
    const [configtxProfile, setConfigtxProfile] = React.useState("");
    const [domain, setDomain] = React.useState("");
    const [dbUsername, setDbUsername] = React.useState("");
    const [dbPassword, setDbPassword] = React.useState("");
    const [caUsername, setCaUsername] = React.useState("");
    const [caPassword, setCaPassword] = React.useState("");

    const [resourceGroupError, setResourceGroupError] = React.useState(false);
    const [locationError, setLocationError] = React.useState(false);
    const [clusterNameError, setClusterNameError] = React.useState(false);
    const [numberNodesError, setNumberNodesError] = React.useState(false);
    const [namespaceError, setNamespaceError] = React.useState(false);
    const [batchTimeoutError, setBatchTimeoutError] = React.useState(false);
    const [maxMessageCountError, setMaxMessageCountError] = React.useState(false);
    const [absoluteMaxBytesError, setAbsoluteMaxBytesError] = React.useState(false);
    const [preferredMaxBytesError, setPreferredMaxBytesError] = React.useState(false);
    const [caError, setCaError] = React.useState(false);
    const [peerError, setPeerError] = React.useState(false);
    const [toolsError, setToolsError] = React.useState(false);
    const [ordererError, setOrdererError] = React.useState(false);
    const [couchdbError, setCouchdbError] = React.useState(false);
    const [countError, setCountError] = React.useState(false);
    const [configtxProfileError, setConfigtxProfileError] = React.useState(false);
    const [domainError, setDomainError] = React.useState(false);
    const [dbUsernameError, setDbUsernameError] = React.useState(false);
    const [dbPasswordError, setDbPasswordError] = React.useState(false);
    const [caUsernameError, setCaUsernameError] = React.useState(false);
    const [caPasswordError, setCaPasswordError] = React.useState(false);

    const classes = useStyles();
    const yaml = require('js-yaml');
    const [modal, setModal] = React.useState(false);
    const [output, setOutput] = React.useState();
    const textAreaRef = useRef(null);
    const [copied, setCopied] = React.useState(false);
    const stepperClasses = useStepperStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [lastOrgNo, setLastOrgNo] = React.useState(1);
    const [lastChannelNo, setLastChannelNo] = React.useState(1);
    const [duplicateOrgsNo, setDuplicateOrgsNo] = React.useState();
    const steps = getSteps();

    const blankOrg = { name: 'Org'+lastOrgNo, domain: 'Org'+lastOrgNo+'.com' };
    const [orgs, setOrgs] = React.useState([
        { ...blankOrg },
    ]);

    const blankOrgPeer = { org: 'org-'+lastOrgNo, name: 'peer'+0, couchdb: true };
    const [orgPeers, setOrgPeers] = React.useState([
        { ...blankOrgPeer },
    ]);

    const blankChannel = { name: '', configtxProfile: '' };
    const [channels, setChannels] = React.useState([
        { ...blankChannel },
    ]);

    const blankChannelOrg = [];
    const [channelOrgs, setChannelOrgs] = React.useState([
        [ ...blankChannelOrg ],
    ]);

    const blankChannelChaincode = { channel: 'channel-'+lastChannelNo, name: '', version: '', path: '', language: '' };
    const [channelChaincodes, setChannelChaincodes] = React.useState([
        { ...blankChannelChaincode },
    ]);

    const handleOrgChange = (e, index, name) => {
        const updatedOrgs = [...orgs];
        updatedOrgs[index][name] = e.target.value;
        if(name == 'name') {
            updatedOrgs[index]['domain'] = e.target.value + '.com'
        }
        setOrgs(updatedOrgs);
    };

    const handleOrgPeerChange = (e, index, name) => {
        const updatedPeers = [...orgPeers];
        if(e.target.value == 'true') {
            updatedPeers[index][name] = true
        } else {
            updatedPeers[index][name] = false
        }
        setOrgPeers(updatedPeers);
    };

    const handleChannelChange = (e, index, name) => {
        const updatedChannels = [...channels];
        updatedChannels[index][name] = e.target.value;
        setChannels(updatedChannels);
    };

    const addOrg = () => {
        const tempOrg = { name: 'Org'+(lastOrgNo+1), domain: 'Org'+(lastOrgNo+1)+'.com' };
        setOrgs([...orgs, { ...tempOrg }]);
        const tempOrgPeer = { org: 'org-'+(lastOrgNo+1), name: 'peer'+0, couchdb: true };
        setOrgPeers([...orgPeers, { ...tempOrgPeer }]);
        setLastOrgNo(lastOrgNo+1)
    };

    const addOrgPeer = (orgNo) => {
        var peerlist = orgPeers.filter((peer) => peer.org == orgNo)
        const tempOrgPeer = { org: orgNo, name: 'peer'+peerlist.length, couchdb: true };
        setOrgPeers([...orgPeers, { ...tempOrgPeer }]);
    };

    const removeOrgPeer = (orgNo) => {
        var index = 0
        orgPeers.map((peer, i) => {
            if(peer.org == orgNo) {
                index = i
            }
        })
        orgPeers.splice(index, 1)
        setOrgPeers([...orgPeers]);
    }

    const deleteOrg = () => {
        var index = orgs.length
        for (var i = orgPeers.length -1; i >= 0; i--) {
            if(orgPeers[i].org == 'org-'+(index)) {
                orgPeers.splice(i, 1)
            }
        }
        setOrgPeers([...orgPeers]);

        orgs.splice(index-1, 1)
        setOrgs([...orgs]);
    }

    const addChannel = () => {
        setChannels([...channels, { ...blankChannel }]);
        setChannelOrgs([...channelOrgs, [ ...blankChannelOrg ]])
        const tempChaincode = { channel: 'channel-'+(lastChannelNo+1), name: '', version: '', path: '', language: '' };
        setChannelChaincodes([...channelChaincodes, { ...tempChaincode }]);
        setLastChannelNo(lastChannelNo+1)
    };

    const handleSelectChange = (e, index) => {
        const tempchannelorgs = [...channelOrgs];
        tempchannelorgs[index] = e.target.value;
        setChannelOrgs(tempchannelorgs)
    };

    const handleChaincodeChange = (e, index, name) => {
        const updatedChaincode = [...channelChaincodes];
        updatedChaincode[index][name] = e.target.value;
        setChannelChaincodes(updatedChaincode);
    };

    const addChannelChaincode = (channelNo) => {
        const tempchaincode = { channel: channelNo, name: '', version: '', path: '', language: '' };
        setChannelChaincodes([...channelChaincodes, { ...tempchaincode }]);
    };

    const removeChannelChaincode = (channelNo) => {
        var index = 0
        channelChaincodes.map((chaincode, i) => {
            if(chaincode.channel == channelNo) {
                index = i
            }
        })
        channelChaincodes.splice(index, 1)
        setChannelChaincodes([...channelChaincodes]);
    } 

    const deleteChannel = () => {
        var index = channels.length
        for (var i = channelChaincodes.length -1; i >= 0; i--) {
            if(channelChaincodes[i].channel == 'channel-'+(index)) {
                channelChaincodes.splice(i, 1)
            }
        }
        setChannelChaincodes([...channelChaincodes]);

        channels.splice(index-1, 1)
        setChannels([...channels]);
    }

    const duplicateOrgs = (event) => {
        var number = event.target.value
        if (number > 0 && number <= 100) {
            setDuplicateOrgsNo(number)
        } else if (number == 0 || number == '') {
            setDuplicateOrgsNo()
            setOrgs([blankOrg])
            setOrgPeers([blankOrgPeer])
        }
    }

    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <div style={{ width: '20%', fontWeight: 'bold' }}>
                                Azure Details
                            </div>
                            <div style={{ width: '30%' }}>
                                <TextField required error={resourceGroupError} fullWidth id="resource-group" label="Resource Group"  margin="dense" variant="outlined" size="small" value={resourceGroup} onChange={(text) => {
                                    setResourceGroup(text.target.value)
                                    setResourceGroupError(false)
                                }} />
                                {resourceGroupError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                            </div>
                            <div style={{ width: '30%', marginLeft: '10%' }}>
                                <TextField required error={locationError} fullWidth id="location" label="Location"  margin="dense" variant="outlined" size="small" value={location} onChange={(text) => {
                                    setLocation(text.target.value)
                                    setLocationError(false)
                                }} />
                                {locationError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <div style={{ width: '20%', fontWeight: 'bold' }}>
                                Kubernetes Details
                            </div>
                            <div style={{ width: '30%' }}>
                                <TextField required error={clusterNameError} fullWidth id="clusterName" label="Cluster Name"  margin="dense" variant="outlined" size="small" value={clusterName} onChange={(text) => {
                                    setClusterName(text.target.value)
                                    setClusterNameError(false)
                                }} />
                                {clusterNameError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                            </div>
                            <div style={{ width: '30%', marginLeft: '10%' }}>
                                <TextField required error={numberNodesError} fullWidth id="numberNodes" label="Number Nodes"  margin="dense" variant="outlined" size="small" value={numberNodes} onChange={(text) => {
                                    setNumberNodes(text.target.value)
                                    setNumberNodesError(false)
                                }} />
                                {numberNodesError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                            </div>
                        </div>
                        <hr></hr>
                    </div>
                )
            case 1:
                return (
                    <div>
                        <div style={{ width: '40%' }}>
                            <TextField required error={namespaceError} fullWidth id="namespace" label="Namespace" margin="dense" variant="outlined" size="small" value={namespace} onChange={(text) => {
                                setNamespace(text.target.value)
                                setNamespaceError(false)    
                            }} />
                            {namespaceError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                        </div>
                        <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', flexDirection: 'row' }}>
                            <div style={{ width: '45%' }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    Genesis Block Conf.
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div style={{ width: '40%' }}>
                                        <TextField required error={batchTimeoutError} fullWidth id="batchTimeout" margin="dense" label="Batch Timeout" variant="outlined" size="small" value={batchTimeout} onChange={(text) => {
                                            setBatchTimeout(text.target.value)
                                            setBatchTimeoutError(false)
                                        }} />
                                        {batchTimeoutError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                        <TextField required error={absoluteMaxBytesError} fullWidth id="absoluteMaxBytes" margin="dense" label="Absolute MaxBytes" variant="outlined" size="small" value={absoluteMaxBytes} onChange={(text) => {
                                            setAbsoluteMaxBytes(text.target.value)
                                            setAbsoluteMaxBytesError(false)    
                                        }} />
                                        {absoluteMaxBytesError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                    <div style={{ width: '40%', marginLeft: '10%' }}>
                                        <TextField required error={maxMessageCountError} fullWidth id="maxMessageCount" margin="dense" label="Max Message Count" variant="outlined" size="small" value={maxMessageCount} onChange={(text) => {
                                            setMaxMessageCount(text.target.value)
                                            setMaxMessageCountError(false)
                                        }} />
                                        {maxMessageCountError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                        <TextField required error={preferredMaxBytesError} fullWidth id="preferredMaxBytes" margin="dense" label="Preferred MaxBytes" variant="outlined" size="small" value={preferredMaxBytes} onChange={(text) => {
                                            setPreferredMaxBytes(text.target.value)
                                            setPreferredMaxBytesError(false)    
                                        }} />
                                        {preferredMaxBytesError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '45%', marginLeft: '10%' }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    Image Versions
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div style={{ width: '40%' }}>
                                        <TextField required error={caError} fullWidth id="ca" label="CA" margin="dense" variant="outlined" size="small" value={ca} onChange={(text) => {
                                            setCa(text.target.value)
                                            setCaError(false)    
                                        }} />
                                        {caError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                        <TextField required error={toolsError} fullWidth id="tools" label="Tools" margin="dense" variant="outlined" size="small" value={tools} onChange={(text) => {
                                            setTools(text.target.value)
                                            setToolsError(false)
                                        }} />
                                        {toolsError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                        <TextField required error={couchdbError} fullWidth id="couchdb" label="CouchDB" margin="dense" variant="outlined" size="small" value={couchdb} onChange={(text) => {
                                            setCouchdb(text.target.value)
                                            setCouchdbError(false)
                                        }} />
                                        {couchdbError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                    <div style={{ width: '40%', marginLeft: '10%' }}>
                                        <TextField required error={peerError} fullWidth id="peer" label="Peer" margin="dense" variant="outlined" size="small" value={peer} onChange={(text) => {
                                            setPeer(text.target.value)
                                            setPeerError(false)
                                        }} />
                                        {peerError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                        <TextField required error={ordererError} fullWidth id="orderer" label="Orderer" margin="dense" variant="outlined" size="small" value={orderer} onChange={(text) => {
                                            setOrderer(text.target.value)
                                            setOrdererError(false)
                                        }} />
                                        {ordererError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr></hr>
                    </div>
                )
            case 2:
                return (
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                            <div style={{ width: '45%' }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    Orderer Conf.
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div style={{ width: '40%' }}>
                                        <TextField required error={countError} fullWidth id="count" label="Count" margin="dense" variant="outlined" size="small" value={count} onChange={(text) => {
                                            setCount(text.target.value)
                                            setCountError(false)    
                                        }} />
                                        {countError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                        <TextField required error={domainError} fullWidth id="domain" label="Domain" margin="dense" variant="outlined" size="small" value={domain} onChange={(text) => {
                                            setDomain(text.target.value)
                                            setDomainError(false)    
                                        }} />
                                        {domainError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                    <div style={{ width: '40%', marginLeft: '10%' }}>
                                        <TextField required error={configtxProfileError} fullWidth id="configtxProfile" label="Configtx Profile" margin="dense" variant="outlined" size="small" value={configtxProfile} onChange={(text) => {
                                            setConfigtxProfile(text.target.value)
                                            setConfigtxProfileError(false)    
                                        }} />
                                        {configtxProfileError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '45%', marginLeft: '10%' }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    CouchDB Conf.
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                                    <div style={{ width: '40%' }}>
                                        <TextField required error={dbUsernameError} fullWidth id="dbUsername" label="Username" margin="dense" variant="outlined" size="small" value={dbUsername} onChange={(text) => {
                                            setDbUsername(text.target.value)
                                            setDbUsernameError(false)    
                                        }} />
                                        {dbUsernameError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                    <div style={{ width: '40%', marginLeft: '10%' }}>
                                        <TextField required error={dbPasswordError} fullWidth id="dbPassword" label="Password" margin="dense" variant="outlined" size="small" value={dbPassword} onChange={(text) => {
                                            setDbPassword(text.target.value)
                                            setDbPasswordError(false)    
                                        }} />
                                        {dbPasswordError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                </div>
                                <div style={{ fontWeight: 'bold' }}>
                                    CA Conf.
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div style={{ width: '40%' }}>
                                        <TextField required error={caUsernameError} fullWidth id="caUsername" label="Username" margin="dense" variant="outlined" size="small" value={caUsername} onChange={(text) => {
                                            setCaUsername(text.target.value)
                                            setCaUsernameError(false)    
                                        }} />
                                        {caUsernameError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                    <div style={{ width: '40%', marginLeft: '10%' }}>
                                        <TextField required error={caPasswordError} fullWidth id="caPassword" label="Password" margin="dense" variant="outlined" size="small" value={caPassword} onChange={(text) => {
                                            setCaPassword(text.target.value)
                                            setCaPasswordError(false)    
                                        }} />
                                        {caPasswordError && <div style={{color: 'red', fontSize: 12}}>This field is Required</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr></hr>
                    </div>
                )
            case 3:
                return (
                    <div style={{marginBottom: 10}}>
                        {duplicateOrgsNo ?
                            <div>
                                <div key={`org-1`} style={{ marginTop: 10, display: 'flex', flexDirection: 'row', marginBottom: 20 }}>
                                    <div style={{ width: '45%' }}>
                                        <div style={{ fontWeight: 'bold' }}>
                                            Org 1
                                        </div>
                                        <TextField required error={resourceGroupError} fullWidth id={'org1'} label="Name" margin="dense" variant="outlined" size="small" value={orgs[0].name} InputProps={{ readOnly: true }}/>
                                        <TextField required error={resourceGroupError} fullWidth id={'domain1'} label="Domain" margin="dense" variant="outlined" size="small" value={orgs[0].domain} InputProps={{ readOnly: true }}/>
                                    </div>
                                    <div style={{ width: '45%', marginLeft: '10%' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ width: '40%', fontWeight: 'bold' }}>
                                                Peers
                                            </div>
                                            <div style={{ width: '40%', marginLeft: '13%', fontWeight: 'bold' }}>
                                                CouchDB
                                            </div>
                                        </div>
                                        {orgPeers.map((peer, j) => {
                                            if (peer.org == 'org-1') {
                                                return (
                                                    <div key={`orgpeer-${j}`} style={{ display: 'flex', flexDirection: 'row' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <TextField required error={resourceGroupError} InputProps={{ readOnly: true }} fullWidth id="org1Peer1Name" margin="dense" variant="outlined" size="small" label="Name" value={orgPeers[j].name} />
                                                        </div>
                                                        <div style={{ width: '40%', marginLeft: '10%' }}>
                                                            <RadioGroup row name="CouchDB" value={orgPeers[j].couchdb}>
                                                                <FormControlLabel
                                                                    value={true}
                                                                    control={<Radio color="primary" />}
                                                                    label="True"
                                                                    labelPlacement="start"
                                                                />
                                                                <FormControlLabel
                                                                    value={false}
                                                                    control={<Radio color="primary" />}
                                                                    label="False"
                                                                    labelPlacement="start"
                                                                />
                                                            </RadioGroup>
                                                        </div>
                                                    </div>)
                                            }
                                        })}
                                    </div>
                                    <div style={{ width: '10%' }}>
                                        <TextField
                                            id="count"
                                            label="Org Count"
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            margin="dense"
                                            size="small"
                                            onChange={(event) => duplicateOrgs(event)}
                                            value={duplicateOrgsNo}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                                <hr></hr>
                            </div>
                            :
                            orgs.map((val, i) => {
                                const orgId = `name-${i}`;
                                const domainId = `domain-${i}`;
                                return (
                                    <div>
                                        <div key={`org-${i}`} style={{ marginTop: 10, display: 'flex', flexDirection: 'row', marginBottom: 20 }}>
                                            <div style={{ width: '45%' }}>
                                                <div style={{ fontWeight: 'bold' }}>
                                                    Org {i + 1}
                                                </div>
                                                <TextField required error={resourceGroupError} fullWidth id={orgId} label="Name" margin="dense" variant="outlined" size="small" value={orgs[i].name} onChange={(e) => handleOrgChange(e, i, "name")} />
                                                <TextField required error={resourceGroupError} fullWidth id={domainId} label="Domain" margin="dense" variant="outlined" size="small" value={orgs[i].domain} onChange={(e) => handleOrgChange(e, i, "domain")} />
                                            </div>
                                            <div style={{ width: '45%', marginLeft: '10%' }}>
                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <div style={{ width: '40%', fontWeight: 'bold' }}>
                                                        Peers
                                                    </div>
                                                    <div style={{ width: '40%', marginLeft: '13%', fontWeight: 'bold' }}>
                                                        CouchDB
                                                    </div>
                                                </div>
                                                {orgPeers.map((peer, j) => {
                                                    if (peer.org == 'org-' + (i + 1)) {
                                                        return (
                                                            <div key={`orgpeer-${j}`} style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <div style={{ width: '40%' }}>
                                                                    <TextField required error={resourceGroupError} InputProps={{ readOnly: true }} fullWidth id="org1Peer1Name" margin="dense" variant="outlined" size="small" label="Name" value={orgPeers[j].name} />
                                                                </div>
                                                                <div style={{ width: '40%', marginLeft: '10%' }}>
                                                                    <RadioGroup row name="CouchDB" value={orgPeers[j].couchdb} onChange={(e) => handleOrgPeerChange(e, j, "couchdb")}>
                                                                        <FormControlLabel
                                                                            value={true}
                                                                            control={<Radio color="primary" />}
                                                                            label="True"
                                                                            labelPlacement="start"
                                                                        />
                                                                        <FormControlLabel
                                                                            value={false}
                                                                            control={<Radio color="primary" />}
                                                                            label="False"
                                                                            labelPlacement="start"
                                                                        />
                                                                    </RadioGroup>
                                                                </div>
                                                            </div>)
                                                    }
                                                })}
                                                <Button color="primary" onClick={() => addOrgPeer('org-' + (i + 1))}>
                                                    <AddIcon /> Peer
                                                </Button>
                                                <Button color="secondary" style={{ marginLeft: 20 }} onClick={() => removeOrgPeer('org-' + (i + 1))}>
                                                    <RemoveIcon /> Peer
                                                </Button>
                                            </div>
                                            {
                                                orgs.length == 1 ?
                                                    <div style={{ width: '10%' }}>
                                                        <TextField
                                                            id="count"
                                                            label="Org Count"
                                                            type="number"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            variant="outlined"
                                                            margin="dense"
                                                            size="small"
                                                            onChange={(event) => duplicateOrgs(event)}
                                                            value={duplicateOrgsNo}
                                                        />
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                        <hr></hr>
                                    </div>
                                )
                            })
                        }
                        {
                            duplicateOrgsNo ?
                                null
                                :
                                <div>
                                    <Button color="primary" onClick={addOrg}>
                                        <AddIcon /> New Org
                                    </Button>
                                    <Button color="secondary" onClick={deleteOrg}>
                                        <RemoveIcon /> Delete Last Org
                                    </Button>
                                </div>
                        }
                    </div>
                )
            case 4:
                return (
                    <div style={{marginBottom: 20}}>
                        {channels.map((channel, k) => {
                            const channelId = `name-${k}`;
                            const configtxProfileId = `configtxProfile-${k}`;
                            return (
                                <div>
                                    <div style={{ width: '40%', fontWeight: 'bold' }}>
                                        Channel {k+1}
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'row', marginBottom: 20}}>
                                        <div style={{width: '45%'}}>
                                            <TextField required error={resourceGroupError} fullWidth id={channelId} margin="dense" variant="outlined" size="small" label="Name" value={channels[k].name} onChange={(e) => handleChannelChange(e, k, "name")} />
                                            <TextField required error={resourceGroupError} fullWidth id={configtxProfileId} margin="dense" variant="outlined" size="small" label="Configtx Profile" value={channels[k].configtxProfile} onChange={(e) => handleChannelChange(e, k, "configtxProfile")} />
                                            <div style={{ width: '40%', fontWeight: 'bold', marginTop: 10 }}>
                                                Select Orgs
                                            </div>
                                            <FormControl size="small" margin="dense" variant="outlined" className={classes.formControl}>
                                                <Select
                                                    multiple
                                                    value={channelOrgs[k]}
                                                    onChange={(e) => handleSelectChange(e, k)}
                                                    renderValue={(selected) => selected.join(', ')}
                                                    MenuProps={MenuProps}
                                                >
                                                    {orgs.map((org, l) => (
                                                        <MenuItem key={orgs[l].name} value={orgs[l].name}>
                                                            <Checkbox checked={channelOrgs[k].indexOf(orgs[l].name) > -1} />
                                                            <ListItemText primary={orgs[l].name} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div style={{ width: '45%', marginLeft: '10%' }}>
                                            {channelChaincodes.map((chaincode, m) => {
                                                if(chaincode.channel == 'channel-'+(k+1)) {
                                                    return (
                                                        <div style={{marginBottom: 10}}>
                                                            <label>Chaincode {m+1}</label>
                                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <div style={{ width: '45%' }}>
                                                                    <TextField required error={resourceGroupError} fullWidth id="chaincodeName" margin="dense" variant="outlined" size="small" label="Name" value={channelChaincodes[m].name} onChange={(e) => handleChaincodeChange(e, m, "name")} />
                                                                    <TextField required error={resourceGroupError} fullWidth id="chaincodeVersion" margin="dense" variant="outlined" size="small" label="Version" value={channelChaincodes[m].version} onChange={(e) => handleChaincodeChange(e, m, "version")} />
                                                                </div>
                                                                <div style={{ width: '45%', marginLeft: '10%' }}>
                                                                    <TextField required error={resourceGroupError} fullWidth id="chaincodePath" margin="dense" variant="outlined" size="small" label="Path" value={channelChaincodes[m].path} onChange={(e) => handleChaincodeChange(e, m, "path")} />
                                                                    <TextField required error={resourceGroupError} fullWidth id="chaincodeLanguage" margin="dense" variant="outlined" size="small" label="Language" value={channelChaincodes[m].language} onChange={(e) => handleChaincodeChange(e, m, "language")} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })}
                                            <Button color="primary" onClick={() => addChannelChaincode('channel-' + (k + 1))}>
                                                <AddIcon /> Chaincode
                                            </Button>
                                            <Button color="secondary" onClick={() => removeChannelChaincode('channel-' + (k + 1))}>
                                                <RemoveIcon /> Chaincode
                                            </Button>     
                                        </div>
                                    </div>
                                    <hr></hr>
                                </div>
                            )
                        })}
                        <Button color="primary" onClick={addChannel}>
                            <AddIcon /> Channel
                        </Button>
                        <Button color="secondary" onClick={deleteChannel}>
                            <RemoveIcon /> Channel
                        </Button>    
                    </div>
                )
            default:
                return 'Unknown step';
        }
    }

    function getSteps() {
    return ['Azure & Kubernetes Details', 'Fabric Details', 'Network Conf.', 'Define Orgs', 'Create Channels'];
    }

    const generateMaster = () => {
        var json = {
            "azure": {
                "resourceGroup": resourceGroup,
                "location": location
            },
            "kubernetes":{
                "clusterName": clusterName,
                "numberNodes": numberNodes
            },
            "fabric": {
                "namespace": namespace,
                "artifacts": artifacts,
                "genesis":{
                    "BatchTimeout": batchTimeout,
                    "MaxMessageCount": maxMessageCount,
                    "AbsoluteMaxBytes": absoluteMaxBytes,
                    "PreferredMaxBytes": preferredMaxBytes
                },
                "imageVersions": {
                    "ca": ca,
                    "peer": peer,
                    "tools": tools,
                    "orderer": orderer,
                    "couchdb": couchdb
                },
                "network":{
                    "core": core,
                    "externalBuilder": externalBuilder,
                    "consortium": consortium,
                    "orderer":{
                        "count": count,
                        "configtxProfile": configtxProfile,
                        "domain": domain,
                    },
                    "couchdb":{
                        "username": dbUsername,
                        "password": dbPassword
                    },
                    "ca":{
                        "username": caUsername,
                        "password": caPassword
                    },
                }
            }
        }

        var orgsarray = []
        orgs.map((org, i) => {
            var orgjson = {}
            orgjson.name = org.name
            orgjson.domain = org.domain
            var peersarray = []
            orgPeers.map((peer) => {
                var peerjson = {}
                if(peer.org == 'org-'+(i+1)) {
                    peerjson.name = peer.name
                    peerjson.couchdb = peer.couchdb
                    peersarray.push(peerjson)
                }
            })
            orgjson.peers = peersarray
            orgsarray.push(orgjson)
        })
        json.fabric.network.orgs = orgsarray

        var channelsarray = []
        channels.map((channel, i) => {
            var channeljson = {}
            channeljson.name = channel.name
            channeljson.configtxProfile = channel.configtxProfile
            var orgsarray = []
            channelOrgs[i].map((org) => {
                var orgsjson = {}
                orgsjson.name = org
                var temporg = orgs.filter((o) => o.name == org)
                var orgindex = orgs.findIndex((o) => o.name == org)
                var peersarray = []
                orgPeers.map((peer) => {
                    var peerjson = {}
                    if (peer.org == 'org-'+(orgindex+1)) {
                        peerjson.name = peer.name
                        peerjson.orgDomain = temporg[0].domain
                        peersarray.push(peerjson)
                    }
                })
                orgsjson.peers = peersarray
                orgsarray.push(orgsjson)
            })
            channeljson.orgs = orgsarray
            var chaincodesarray = []
            channelChaincodes.map((chaincode) => {
                var chaincodejson = {}
                if (chaincode.channel == 'channel-'+(i+1)) {
                    chaincodejson.name = chaincode.name
                    chaincodejson.version = chaincode.version
                    chaincodejson.path = chaincode.path
                    chaincodejson.language = chaincode.language
                    chaincodesarray.push(chaincodejson)
                }
            })
            channeljson.chaincode = chaincodesarray
            channelsarray.push(channeljson)
        })
        json.fabric.network.channels = channelsarray

        const res = yaml.dump(json);
        setOutput(res)
        setModal(true) 
    }

    const body = (
        <div style={{width: 500}}>
            <TextField
                ref={textAreaRef}
                fullWidth
                id="outlined-multiline-static"
                label="Master.yaml"
                multiline
                rows={16}
                variant="outlined"
                value={output}
                onChange={() => setCopied(false)}
            />
        </div>
    );

    const download = () => {
        fileDownload(output, 'Master.yaml');
    }

    const handleNext = () => {
        if (activeStep == 0) {
            var proceed = true
            if(resourceGroup.length < 1) {
                setResourceGroupError(true)
                proceed = false
            }
            if(location.length < 1) {
                setLocationError(true)
                proceed = false
            }
            if(clusterName.length < 1) {
                setClusterNameError(true)
                proceed = false
            }
            if(numberNodes.length < 1) {
                setNumberNodesError(true)
                proceed = false
            }
            if(proceed) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        } else if (activeStep == 1) {
            var proceed = true
            if(namespace.length < 1) {
                setNamespaceError(true)
                proceed = false
            } if(batchTimeout.length < 1) {
                setBatchTimeoutError(true)
                proceed = false
            } if(absoluteMaxBytes.length < 1) {
                setAbsoluteMaxBytesError(true)
                proceed = false
            } if(maxMessageCount.length < 1) {
                setMaxMessageCountError(true)
                proceed = false
            } if(preferredMaxBytes.length < 1) {
                setPreferredMaxBytesError(true)
                proceed = false
            } if(ca.length < 1) {
                setCaError(true)
                proceed = false
            } if(tools.length < 1) {
                setToolsError(true)
                proceed = false
            } if(couchdb.length < 1) {
                setCouchdbError(true)
                proceed = false
            } if(peer.length < 1) {
                setPeerError(true)
                proceed = false
            } if(orderer.length < 1) {
                setOrdererError(true)
                proceed = false
            }
            if(proceed) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        } else if (activeStep == 2) {
            var proceed = true
            if(count.length < 1) {
                setCountError(true)
                proceed = false
            } if(domain.length < 1) {
                setDomainError(true)
                proceed = false
            } if(configtxProfile.length < 1) {
                setConfigtxProfileError(true)
                proceed = false
            } if(dbUsername.length < 1) {
                setDbUsernameError(true)
                proceed = false
            } if(dbPassword.length < 1) {
                setDbPasswordError(true)
                proceed = false
            } if(caUsername.length < 1) {
                setCaUsernameError(true)
                proceed = false
            } if(caPassword.length < 1) {
                setCaPasswordError(true)
                proceed = false
            }
            if(proceed) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
        } else if (activeStep == 3) {
            if (duplicateOrgsNo > 0) {
                var initialOrg = [{ name: 'Org1', domain: 'Org1.com' }]
                var peerlength = orgPeers.length
                var initialPeer = [...orgPeers]
                for (var i = 2; i <= duplicateOrgsNo; i++) {
                    var tempOrg = { name: 'Org' + i, domain: 'Org' + i + '.com' }
                    initialOrg = [...initialOrg, tempOrg]
    
                    for (var j = 0; j < peerlength; j++) {
                        const tempOrgPeer = { org: 'org-' + i, name: 'peer' + j, couchdb: orgPeers[j].couchdb };
                        initialPeer = [...initialPeer, tempOrgPeer]
                    }
                }
                setOrgs(initialOrg)
                setOrgPeers(initialPeer)
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    function autofill () {
        setDuplicateOrgsNo()
        setResourceGroup("aks-test")
        setLocation("westeurope")
        setClusterName("aks-test-cluster")
        setNumberNodes(2)
        setNamespace("fabtest")
        setBatchTimeout("2s")
        setMaxMessageCount(10)
        setAbsoluteMaxBytes("99 MB")
        setPreferredMaxBytes("512 KB")
        setCa("1.4.8")
        setPeer("2.2.0")
        setTools("2.2.0")
        setOrderer("2.2.0")
        setCouchdb(3.1)
        setCount(3)
        setConfigtxProfile("TwoOrgsOrdererGenesis")
        setDomain("soprasteria.com")
        setDbUsername("admin")
        setDbPassword("adminpw")
        setCaUsername("admin")
        setCaPassword("adminpw")
        setOrgs([{ name: 'Org1', domain: 'org1.example.com' }, { name: 'Org2', domain: 'org2.example.com' }])
        setOrgPeers([{ org: 'org-1', name: 'peer0', couchdb: true }, { org: 'org-1', name: 'peer1', couchdb: true }, { org: 'org-2', name: 'peer0', couchdb: true }, { org: 'org-2', name: 'peer1', couchdb: true }])
        setChannels([{ name: 'channel1', configtxProfile: 'TwoOrgsChannel1' }])
        setChannelOrgs([['Org1', 'Org2']])
        setChannelChaincodes([{ channel: 'channel-1', name: 'fabcar', version: 1, path: 'chaincodes/fabcar', language: 'golang' }])
        setLastOrgNo(2)
    }

    return (
        <div style={{ backgroundColor: "#0F171E" }}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={11}>
                    <Card style={{ backgroundColor: "#D3D3D3" }} >
                        <CardHeader color="warning">
                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <div style={{ width: '90%' }}>
                                    <h4 className={classes.cardTitleWhite}>Fill the Configuration form</h4>
                                </div>
                                <div>
                                    <input
                                        type="button"
                                        value="Load Default"
                                        onClick={autofill}
                                    />
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className={stepperClasses.root}>
                                <Stepper activeStep={activeStep} orientation="vertical">
                                    {steps.map((label, index) => (
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                            <StepContent>
                                                <Typography>{getStepContent(index)}</Typography>
                                                <div className={stepperClasses.actionsContainer}>
                                                    <div>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={handleBack}
                                                            className={stepperClasses.button}
                                                        >
                                                            Back
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={handleNext}
                                                            className={stepperClasses.button}
                                                        >
                                                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </StepContent>
                                        </Step>
                                    ))}
                                </Stepper>
                                {activeStep === steps.length && (
                                    <Paper square elevation={0} className={stepperClasses.resetContainer}>
                                        <Typography>All steps completed - you&apos;re finished</Typography>
                                        <Button onClick={handleReset} className={stepperClasses.button}>
                                            Reset
                                        </Button>
                                        <Button  variant="contained" color="secondary" onClick={generateMaster} className={stepperClasses.button}>
                                            Generate
                                        </Button>
                                    </Paper>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            <Dialog
                onClose={() => {
                    setModal(false)
                }}
                aria-labelledby="customized-dialog-title"
                open={modal}
            >
                <DialogTitle
                    id="customized-dialog-title"
                    onClose={() => {
                        setModal(false)
                    }}
                >
                    Master.yaml
                </DialogTitle>
                <DialogContent>
                    {body}
                </DialogContent>
                <DialogActions>
                    <CopyToClipboard text={output}
                        onCopy={() => setCopied(true)}>
                        <button>Copy</button>
                    </CopyToClipboard>
                    <Button onClick={download} color="primary" autoFocus>
                        Download
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}